import { combinations, isIncompatible } from '../../../../config/combinationConfig';
export const areSelectionsIncompatible = (newSelection, oldSelection) => {
    if (newSelection.category === oldSelection.category) {
        const { combinationType } = combinations[newSelection.category] || combinations.DEFAULT;
        return isIncompatible[combinationType](newSelection, oldSelection);
    }
    return false;
};
